import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SubCategoriaNoEncontrada from "./Componentes/SubCategoriaNoEncontrada";
import SubCategoriaEncontrada from "./Componentes/SubCategoriaEncontrada";

export default function SubResultadosBarraBusqueda({
  datosAMostrar = [],
  vIsFocus = false,
  esBusquedaCursos = false,
}) {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 464);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth <= 464);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const mCrearEstilo = () => {
    if (vIsFocus) {
      if (datosAMostrar.length === 0) {
        return {
          height: "45px",
          paddingTop: isSmallScreen ? "3px" : "15px",
          paddingBottom: "15px",
        };
      } else {
        const baseHeight = 45;
        const extraHeight = Math.min(datosAMostrar.length, 4) * baseHeight;
        return {
          height: `${extraHeight}px`,
          paddingTop: "10px",
          paddingBottom: "10px",
        };
      }
    } else {
      return { height: "0px", paddingTop: "0px", paddingBottom: "0px" };
    }
  };

  return (
    <div className="box-menu-organizacion-resultados" style={mCrearEstilo()}>
      {datosAMostrar.length === 0 ? (
        <SubCategoriaNoEncontrada esBusquedaCursos={esBusquedaCursos} />
      ) : (
        datosAMostrar.map((item, index) => (
          <React.Fragment key={item.id}>
            {esBusquedaCursos ? (
              <div
                className="menu-organizacion-ejemplo"
                onClick={() => navigate(`/curso-no-comprado/${item.id}`)}
              >
                <p className="menu-organizacion-ejemplo-texto truncate-1-line">
                  {item.nombre}
                </p>
              </div>
            ) : (
              <SubCategoriaEncontrada
                nombre={item.nombre}
                totalCursos={item.total_cursos}
                id={item.id}
              />
            )}

            {datosAMostrar.length - 1 !== index && (
              <div className="linea"></div>
            )}
          </React.Fragment>
        ))
      )}
    </div>
  );
}
